import type { ChangeRequest, EventType } from 'models';
import { EventDetailCountdown } from '../../components';

type P = {
  changeRequests?: ChangeRequest[];
  eventType: EventType;
  startTime: Date;
};

const EventDetailCountdownWrapper = ({ eventType, ...props }: P) => {
  if (eventType === 'reminder') {
    return null;
  }

  return <EventDetailCountdown {...props} />;
};

export default EventDetailCountdownWrapper;
